
<!-- prettier-ignore -->

<div class="user-wrapper">
  <h1 class="register-heading">{{'Nombre y email' | translate}}</h1>

  <form [formGroup]="userData" class="user" #registerFormRef="ngForm" (ngSubmit)="onSubmit()">
    <div class="user__data" >
      <label class="user__label"><span>{{'Nombre' | translate}}</span></label>
      <div class="user__input-wrapper">
          <input autocomplete="off" type="text" id="nombre" formControlName="name" class="user__input" [ngClass]="{'border-error': f.name.touched && f.name.invalid}" />
          @if(f.name.touched && f.name.invalid){
            <div class="user__input__error-message">
              @if(f.name.errors?.required){
                <small class="error">{{'El nombre es obligatorio' | translate}}</small>
              }
              @if(f.name.errors?.minlength){
                <small class="error">{{'El nombre debe tener al menos 3 caracteres' | translate}}</small>
              }
            </div>
          }

        </div>
    </div>

    <div class="user__data" >
      <label class="user__label">
        <span>{{'Email' | translate}}</span>
      </label>
      <div class="user__input-wrapper">
          <input autocomplete="off" type="email" id="email" formControlName="email" class="user__input" [ngClass]="{'border-error': f.email.touched && f.email.invalid}" />
          @if(f.email.touched && f.email.invalid){
            <div class="user__input__error-message">
              <small class="error">{{'Introduzca email válido' | translate}}</small>
            </div>
          }
      </div>
    </div>
  </form>

  <register-action-buttons-standalone [isLastSlide]="true" (actionButtonsEmiter)="formAction($event)" [sendButtonDisabled]="f.name.invalid || f.email.invalid" />

</div>


